export const getLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) { // GPS를 지원하면
      navigator.geolocation.getCurrentPosition(function(position) {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        })
      }, function(error) {
        reject(error);
      }, {
        enableHighAccuracy: false,
        maximumAge: 0,
        timeout: Infinity
      });
    } else {
      alert('GPS를 지원하지 않습니다.');
      resolve({
        latitude: 0,
        longitude: 0
      })
    }
  });
}